<app-loader></app-loader>
<router-outlet></router-outlet>

<!--<display-message [Errormessage]="message1" >

</display-message>-->
